// The outlier message ("2.1 °F higher than your last 10 readings ...")
// built from its numbers, in the keeper's units. Readings are stored in
// °F and ppt, and until 2026-09-27 the message was written once, in those
// units, so a keeper on °C or S.G. saw °F and ppt in the warning under a
// value shown in their own unit. The stored outlier_reason keeps the
// storage-unit text (Siri readback, the AI evidence, rows saved before
// outlier_detail existed); screens render from outlier_detail.

const PPT_PER_SG = 35 / 0.026;

const STORAGE_UNIT = {
  alk: 'dKH',
  calcium: 'ppm',
  magnesium: 'ppm',
  nitrate: 'ppm',
  phosphate: 'ppm',
  ph: '',
  salinity: 'ppt',
  temp: '°F',
};

function trim(n, k = 2) {
  if (!Number.isFinite(n)) return String(n);
  return Number(n.toFixed(k)).toString();
}

// A level and a difference convert differently: 2 °F apart is 1.1 °C
// apart, while 78 °F is 25.6 °C.
function unitFormat(param, units) {
  if (param === 'temp' && units?.temp === 'C') {
    return {
      level: (v) => trim(((v - 32) * 5) / 9, 1),
      diff: (v) => trim((v * 5) / 9, 1),
      tail: ' °C',
    };
  }
  if (param === 'salinity' && units?.salinity === 'sg') {
    return {
      level: (v) => trim(1 + v / PPT_PER_SG, 4),
      diff: (v) => trim(v / PPT_PER_SG, 4),
      tail: ' S.G.',
    };
  }
  if (param === 'salinity' && units?.salinity === 'psu') {
    return { level: (v) => trim(v), diff: (v) => trim(v, 2), tail: ' PSU' };
  }
  const unit = STORAGE_UNIT[param] || '';
  return { level: (v) => trim(v), diff: (v) => trim(v, 2), tail: unit ? ` ${unit}` : '' };
}

export function outlierText(detail, units = null) {
  if (!detail || typeof detail !== 'object') return null;
  const f = unitFormat(detail.param, units);
  const n = Number(detail.n);
  const mean = Number(detail.mean);
  if (detail.kind === 'flat') {
    return `your last ${n} readings were all ${f.level(mean)}${f.tail}. Worth a retest.`;
  }
  if (detail.kind === 'z') {
    const dir = detail.direction === 'lower' ? 'lower' : 'higher';
    return `${f.diff(Number(detail.delta))}${f.tail} ${dir} than your last ${n} readings (avg ${f.level(mean)}${f.tail}). Worth a retest.`;
  }
  if (detail.kind === 'band') {
    return `crossed your ${f.level(Number(detail.lo))}–${f.level(Number(detail.hi))}${f.tail} band — recent average (${f.level(mean)}${f.tail}) was inside it. Worth a retest.`;
  }
  return null;
}
